import React, { Ref, useCallback } from "react";
import Switch from "@coworker/apprestructured/src/task-management/components/Switch/Switch";
import {
  FragmentIconName,
  useFragmentIcon,
} from "@coworker/apprestructured/src/task-management/fragments/useFragmentIcon";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";

export type SwitchCreatorFragmentConfigProps = {
  field: string;
  label: string;
  icon: FragmentIconName;
};

type SwitchCreatorFragmentProps = {
  configProps: SwitchCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function SwitchCreatorFragment({
  configProps,
  commonProps,
}: SwitchCreatorFragmentProps) {
  const { field, label, icon: iconName } = configProps;
  const { blockInput, task, onTaskChange } = commonProps;
  const icon = useFragmentIcon(iconName);
  const checked = getByPath<boolean>(task, field);
  const { t } = useTranslation();
  const handleCheckedChange = useCallback(
    (newChecked: boolean) => {
      onTaskChange(setByPath(field, newChecked));
    },
    [field, onTaskChange]
  );

  return (
    <Switch
      icon={icon}
      checked={isLoading(checked) ? false : checked}
      onCheckedChange={handleCheckedChange}
      label={t(label)}
      disabled={blockInput || isLoading(checked)}
    />
  );
}

export default SwitchCreatorFragment;
